import React from 'react';

import { VGSFormProvider } from 'src/app/shared/components/VGSFormProvider';
import { useFormContext } from 'rhf-v7';
import { RetryPaymentCheckoutFormValues } from '../FormProvider/types';

interface IProps {
  children?: React.ReactNode;
}

export const VGSFormProviderContainer: React.FC<IProps> = ({ children }) => {
  const { watch } = useFormContext<RetryPaymentCheckoutFormValues>();
  const allPaymentSourceIds = watch('selectedPaymentSourceIds');

  return <VGSFormProvider paymentSourceIds={allPaymentSourceIds}>{children}</VGSFormProvider>;
};
